var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2187_42668)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 5.60156,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 5.60156,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "url(#paint0_radial_2187_42668)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 5.60156,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "url(#paint1_radial_2187_42668)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.37488,
    y: 4.90613,
    width: 30.5989,
    height: 30.5989,
    rx: 15.2994,
    stroke: "white",
    strokeWidth: 1.39086
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.26 14.6406H19.4414C19.9083 14.6599 20.356 14.8877 20.6725 15.2273C20.989 14.8877 21.4328 14.6599 21.9037 14.6406H22.0812C22.2703 14.6561 22.4594 14.6831 22.6408 14.741C23.2313 14.9224 23.7369 15.3585 24.0109 15.9105C24.2502 16.3775 24.3158 16.9295 24.2077 17.4428C24.1305 17.8211 23.9337 18.1646 23.679 18.4502C23.405 18.759 23.0769 19.0099 22.745 19.2531C22.3475 19.5425 21.9423 19.8243 21.5486 20.1215C21.2476 20.3492 20.9581 20.5963 20.6725 20.8433C20.4757 20.6735 20.2827 20.5036 20.0782 20.3415C19.6884 20.0327 19.2754 19.751 18.8702 19.4615C18.573 19.2531 18.2835 19.0369 18.0134 18.7976C17.7548 18.5622 17.5117 18.2997 17.3457 17.9909C17.145 17.6281 17.064 17.2035 17.091 16.7905C17.1257 16.2116 17.392 15.6557 17.8165 15.2621C18.2063 14.8915 18.7274 14.6715 19.26 14.6406ZM20.3483 16.6168C20.3483 16.833 20.3483 17.053 20.3483 17.2691C20.1322 17.2691 19.9122 17.2691 19.6961 17.2691C19.6961 17.4853 19.6961 17.7053 19.6961 17.9214C19.9122 17.9214 20.1322 17.9214 20.3483 17.9214C20.3483 18.1376 20.3483 18.3576 20.3483 18.5737C20.5644 18.5737 20.7844 18.5737 21.0006 18.5737C21.0006 18.3576 21.0006 18.1376 21.0006 17.9214C21.2167 17.9214 21.4367 17.9214 21.6528 17.9214C21.6528 17.7053 21.6528 17.4853 21.6528 17.2691C21.4367 17.2691 21.2167 17.2691 21.0006 17.2691C21.0006 17.053 21.0006 16.833 21.0006 16.6168C20.7806 16.6168 20.5644 16.6168 20.3483 16.6168Z",
    fill: "#516CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3139 17.7476C15.3602 17.6626 15.4567 17.5854 15.5571 17.6163C15.696 17.6626 15.7732 17.7977 15.8349 17.9212C15.9932 18.2609 16.0704 18.6314 16.136 18.9981C16.2325 19.5423 16.2904 20.0943 16.3367 20.6462C16.3521 20.9164 16.4486 21.1789 16.5682 21.4221C16.7419 21.7694 16.985 22.0782 17.2938 22.3098C17.7569 22.6456 18.2201 22.9814 18.6832 23.3172C18.8144 23.1435 18.9456 22.9698 19.073 22.7961C18.6523 22.4912 18.2316 22.1863 17.811 21.8775C17.5369 21.6922 17.2784 21.4529 17.1587 21.1364C17.1163 21.0168 17.097 20.8701 17.178 20.7659C17.2591 20.6655 17.3941 20.6385 17.5176 20.6347C17.7878 20.6308 18.0502 20.7234 18.2972 20.8277C18.7218 21.0129 19.1193 21.2561 19.5014 21.5108C19.9375 21.781 20.2385 22.2519 20.3196 22.7575C20.3505 22.9428 20.3427 23.1319 20.3427 23.3211C20.3427 24.1316 20.3427 24.9422 20.3427 25.7566H18.3899C18.3822 25.4054 18.1969 25.085 17.9846 24.811C17.6103 24.3208 17.1356 23.9193 16.6956 23.4948C16.3482 23.1628 15.997 22.827 15.6999 22.4488C15.476 22.1554 15.2715 21.8235 15.2174 21.4491C15.148 20.7775 15.1171 20.0982 15.1094 19.4188V19.2683C15.1171 18.9171 15.121 18.562 15.175 18.2107C15.202 18.0525 15.2367 17.8904 15.3139 17.7476Z",
    fill: "#516CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6197 17.7469C25.6776 17.6775 25.7625 17.6118 25.859 17.6273C25.9555 17.6466 26.0134 17.7392 26.0558 17.8203C26.133 17.9901 26.16 18.1792 26.1832 18.3645C26.2179 18.627 26.2179 18.8971 26.2334 19.1596V20.0782L26.2141 19.9586C26.2218 20.2211 26.2025 20.4835 26.187 20.7498C26.1677 21.0084 26.1523 21.2709 26.1137 21.5257C26.0365 21.9309 25.7934 22.2822 25.5348 22.5948C25.0331 23.1892 24.431 23.691 23.8791 24.2352C23.636 24.4784 23.4044 24.737 23.2114 25.0265C23.0686 25.2503 22.9567 25.5012 22.9529 25.7676H21C21 24.8605 21 23.9573 21 23.0503C21 22.6141 21.1621 22.178 21.4554 21.8537C21.6098 21.6762 21.8028 21.5411 21.9957 21.4137C22.3045 21.213 22.6248 21.0316 22.9606 20.8811C23.2076 20.773 23.4662 20.6726 23.7402 20.6495C23.8753 20.6418 24.0258 20.6533 24.1338 20.746C24.2265 20.827 24.238 20.9583 24.211 21.0702C24.1609 21.2709 24.0374 21.4446 23.8946 21.5951C23.7556 21.7418 23.5858 21.8537 23.4237 21.9695C23.0416 22.2474 22.6557 22.5253 22.2736 22.8071C22.4048 22.9808 22.5322 23.1545 22.6634 23.3282C23.1227 22.9962 23.5819 22.6604 24.0412 22.3285C24.2882 22.1509 24.4928 21.9155 24.6549 21.6607C24.8478 21.3442 24.9945 20.993 25.0138 20.6186C25.0408 20.3098 25.0678 20.001 25.1064 19.6961C25.1682 19.2175 25.2415 18.7389 25.3804 18.2757C25.4306 18.0866 25.4962 17.8975 25.6197 17.7469Z",
    fill: "#516CD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2187_42668",
    x: 0.507115,
    y: 0.0383649,
    width: 40.3373,
    height: 40.3373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08629
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2187_42668"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2187_42668",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2187_42668",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.778 11.6866) rotate(51.0441) scale(24.5185 24.5185)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2187_42668",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2772 31.1586) rotate(-93.6705) scale(24.9998 27.8633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516CD3",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#516CD3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopColor: "#516CD3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareTeam);
export default __webpack_public_path__ + "static/media/careTeam.fb9d49f9e4f5e65d4afaa34d82b2c2aa.svg";
export { ForwardRef as ReactComponent };